import { makeVar } from '@apollo/client';

export interface IAcademicProgramListWizardCache {
  error: string;
  data: string[];
}

export const emptyAcademicProgramListWizardCache: IAcademicProgramListWizardCache = {
  error: '',
  data: [],
};

export const academicProgramListWizardReactiveVars = makeVar<IAcademicProgramListWizardCache>(
  emptyAcademicProgramListWizardCache,
);
